
// Vendor
import { Component, Vue, Prop, Model } from 'vue-property-decorator';

// Internal
import { LavorazioneSlim, MetadataType, StatoLavorazione } from '@/models';
import { StoreActions, StoreMutations } from '@/store';
import StatoWorkflow from './StatoWorkflow.vue';

@Component({
  components: {
    StatoWorkflow
  }
})
export default class ItemListLavorazione extends Vue {
  @Prop() public lavorazione!: LavorazioneSlim;
  @Prop({ default: false }) public compact!: boolean;
  @Prop({ default: true }) public workflow!: boolean;
  @Model('change', { type: Boolean }) checked!: boolean;

  private metadataType = MetadataType;

  get selezioneRigheAttiva(): boolean {
    if(!this.$route.meta) return false;
    return this.$route.meta.selezioneRigheAttiva;
  }

  get listaLavorazioniSelezionate(): LavorazioneSlim[] {
    return this.$store.state.listaLavorazioniSelezionate;
  }

  get lavorazioneSelezionata(): boolean {
    return (
      this.listaLavorazioniSelezionate.find(
        (lavorazioneSelezionata: LavorazioneSlim) =>
          lavorazioneSelezionata.id === this.lavorazione.id
      ) !== void 0
    );
  }

  public iconClassByProgress(): string {
    switch (this.lavorazione.progresso) {
      case 0:
        return 'grey';
      case 100:
        return 'green';
      default:
        return 'amber';
    }
  }

  public getChipColorByHashedString(nome: string): string {
      const colorArray = ["grey", "red", "pink", "purple", "deep-purple", "indigo", "blue",
      "light-blue", "cyan", "teal", "green", "light-green", "lime", "yellow", "amber",
      "orange", "deep-orange", "brown", "blue-grey"];
      var hash = 0, i, chr;
      for (i = 0; i < nome.length; i++) {
        chr   = nome.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      if(hash < 0) hash = -hash;
      return colorArray[hash % colorArray.length];
  }

  public showDetail() {
    this.$router.push({ name: 'riga', params: { id: this.lavorazione.id } });
  }

  public toggleSelezioneLavorazione(e: Event): void {
    if (this.selezioneRigheAttiva) {
      this.$store.commit(
        StoreMutations.ToggleLavorazioneSlim,
        this.lavorazione
      );

      e.preventDefault();
      e.stopPropagation();
    }
  }
}
